import type { NeffiStatus } from './types';

const HIGH_QUALITY_THRESHOLD = 80;
const MEDIUM_QUALITY_THRESHOLD = 50;

export const getNeffiScoreStatus = (normalizedScore: number): NeffiStatus => {
  return normalizedScore >= HIGH_QUALITY_THRESHOLD
    ? 'high'
    : normalizedScore >= MEDIUM_QUALITY_THRESHOLD
      ? 'medium'
      : 'low';
};
